/// <amd-module name="VSSUI/Components/VssContextualMenu/index" />

export * from "./VssContextualMenu";
export { IVssContextualMenuGroup, IVssContextualMenuItem, IVssContextualMenuItemProvider, IVssContextualMenuProps } from "./VssContextualMenu.Props";
